import { Component, Input } from '@angular/core';

@Component({
  selector: 'pds-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  standalone: false,
})
export class TableComponent {
  @Input()
  height: number | undefined;
}
